import React, { useEffect, useState } from 'react';
import {
  getInvoiceConfigs,
  createInvoiceConfig,
  updateInvoiceConfig,
} from '../service';
import { SETTINGS_MOCK } from '../constants';
import { handleAPIError } from '../../../utils/apiUtils';

const useInvoiceConfigState = () => {
  const [invoiceConfigs, setInvoiceConfigs] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchInvoiceConfigs = async () => {
    try {
      setLoading(true);
      const data = await getInvoiceConfigs();
      setInvoiceConfigs(data);
    } catch (error) {
      console.error('Failed to fetch invoices configs', error);
      setInvoiceConfigs(SETTINGS_MOCK);
    } finally {
      setLoading(false);
    }
  };

  const sortAndSetInvoiceConfigs = (invoiceConfigsList) => {
    invoiceConfigsList.sort((a, b) => {
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      return 0;
    });
    setInvoiceConfigs(invoiceConfigsList);
  }

  const addOrUpdate = async (invoiceConfig) => {
    let response = {
      success: false,
      code: null,
      message: null,
    };
    try {
      if (invoiceConfig.id) {
        const updated = await updateInvoiceConfig(invoiceConfig.id, invoiceConfig);
        const updatedInvoiceConfigs = invoiceConfigs.map(c => (c.id === updated.id ? updated : c));
        sortAndSetInvoiceConfigs(updatedInvoiceConfigs);
        response.success = true;
      } else {
        const created = await createInvoiceConfig(invoiceConfig);
        const updatedInvoiceConfigs = [...invoiceConfigs, created];
        sortAndSetInvoiceConfigs(updatedInvoiceConfigs);
        response.success = true;
      }
      fetchInvoiceConfigs();
    } catch (error) {
      response = handleAPIError(error);
      console.error('Failed to add or update invoiceConfig', error);
    }
    return response;
  };

  useEffect(() => {
    fetchInvoiceConfigs();
  }, []);

  return { invoiceConfigs, loading, addOrUpdate };
};

export default useInvoiceConfigState;
